import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { enderecosService } from '../../services';
import { Endereco } from '../../types/pessoas';

const columns: ResourceColumn<Endereco>[] = [
  { header: 'Logradouro', accessor: 'logradouro' },
  { header: 'Bairro', accessor: 'bairro' },
  { header: 'CEP', accessor: 'cep' },
  { header: 'Cidade', render: (item) => item.cidade_nome ?? `ID ${item.cidade}` },
];

export const EnderecosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Endereços"
      description="Cadastro de endereços que podem ser vinculados a entidades."
      columns={columns}
      service={enderecosService}
      createPath="/admin/pessoas/enderecos/novo"
      onEdit={(item) =>
        item.id && navigate('/admin/pessoas/enderecos/editar', { state: { record: item } })
      }
      onDelete={(item) => (item.id ? enderecosService.remove(item.id) : Promise.resolve())}
    />
  );
};
